export async function boxIndexUseCase(boxRepository) {
    const result = await boxRepository.index();

    result.forEach(x => {
        x = new boxRepository.model(x);

        if (!x.isValid()) {
            throw new Error("box inválido");
        }
    })

    return result;
}